export default {
  included: {
    id: 'service_drawer_included',
    defaultMessage: 'Included*',
  },
  notIncluded: {
    id: 'service_drawer_not_included',
    defaultMessage: 'Not included',
  },
  crackedScreen: {
    id: 'service_drawer_cracked_screen',
    defaultMessage: 'Cracked screen',
  },
  crackedRearGlassOrDamagedBody: {
    id: 'service_drawer_cracked_rear_glass_or_damaged_body',
    defaultMessage: 'Cracked rear glass or damaged body',
  },
  waterDamage: {
    id: 'service_drawer_water_damage',
    defaultMessage: 'Water damage',
  },
  stuckPowerOrVolumeButtons: {
    id: 'service_drawer_stuck_power_or_volume_buttons',
    defaultMessage: 'Stuck power or volume buttons',
  },
  physicalFaults: {
    id: 'service_drawer_physical_faults',
    defaultMessage:
      'Physical faults (e.g. camera, ports, keyboard not working)',
  },
  softwareFaults: {
    id: 'service_drawer_software_faults',
    defaultMessage: 'Software faults',
  },
  batteryHealthDegradation: {
    id: 'service_drawer_battery_health_degradation',
    defaultMessage: 'Battery health degradation**',
  },
  theftOrLoss: {
    id: 'service_drawer_theft_or_loss',
    defaultMessage: 'Theft or loss',
  },
  nonExhaustiveNote: {
    id: 'service_drawer_non_exhaustive_note',
    defaultMessage:
      '*Non exhaustive. Other cosmetic and physical issues may be included.',
  },
  batteryHealthDegradationNote: {
    id: 'service_drawer_battery_health_degradation_note',
    defaultMessage:
      '**Battery health degradation from normal use is not included in this plan.',
  },
}
